import classNames from 'classnames'
import { useTheme } from '@opallabs/hooks'
import { ColorLabelToken } from '../../../ColorToken'
import { singleSelectClasses } from '../componentClassNames'
import { useSingleSelectState } from '../contexts'
import * as styles from './styles'

type TriggerTextProps = {
  className?: string
  placeholder?: string | null
}

export const TriggerText: React.FC<TriggerTextProps> = ({
  className,
  placeholder = 'Select...',
}) => {
  const theme = useTheme()
  const { isInvalidSelection, selectedItem } = useSingleSelectState()

  if (selectedItem?.color) {
    return (
      <ColorLabelToken color={selectedItem.color} label={selectedItem.label} />
    )
  }

  return (
    <span
      className={classNames(singleSelectClasses.triggerText, className)}
      aria-invalid={isInvalidSelection}
      css={styles.selectionText({
        theme,
        isPlaceholder: !!placeholder && !selectedItem?.label,
      })}
    >
      {selectedItem?.label ?? placeholder}
    </span>
  )
}
TriggerText.displayName = 'Lapidary: TriggerText ← SingleSelect'
